import { Button } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'
import { withSuspense } from '@festina-life/ui/libs'
import { Modal } from '@festina-life/ui/structure'
import { useId } from 'react'

import { AddBalancePostingForm } from './AddBalancePostingForm'
import type { SingletonBalancePostingPair } from './types'

type Props = {
  posting: SingletonBalancePostingPair
  onClose: () => void
  onSubmit: (values: SingletonBalancePostingPair) => void
}

const EditBalancePostingModalInternal = ({
  posting,
  onClose,
  onSubmit,
}: Props) => {
  const translate = useTranslate()

  const formId = useId()

  return (
    <Modal isOpen onClose={onClose}>
      <Modal.Title
        title={translate('collectivePots.action.editBalancePosting')}
      />
      <Modal.Body>
        <AddBalancePostingForm
          initialValues={posting}
          onSubmit={onSubmit}
          formId={formId}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="discreet" onClick={onClose}>
          {translate('cancel')}
        </Button>
        <Button variant="primary" type="submit" form={formId}>
          {translate('apply')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export const EditBalancePostingModal = withSuspense(
  EditBalancePostingModalInternal,
)
